import { useParams } from 'react-router-dom'

import { FileCopyOperationDetail } from './FileCopyOperationDetail'

export const FileCopyDetailPage = (): JSX.Element => {
  const params = useParams()

  return <FileCopyOperationDetail operationId={params.operationId as string} />
}
